/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BillingDiscount = {
    name: string | null;
    percent_off: number | null;
    amount_off: number | null;
    duration: BillingDiscount.duration;
    duration_in_months: number | null;
};
export namespace BillingDiscount {
    export enum duration {
        FOREVER = 'forever',
        ONCE = 'once',
        REPEATING = 'repeating',
    }
}

